import React, { useState } from "react"
import "../../Styles/index.scss"
//import "../../Styles/singlepost.scss"
import Post from "../post"
import { graphql, StaticQuery } from "gatsby"
import { Row, Col } from "react-bootstrap"
import Img from "gatsby-image"
import { Link } from "gatsby"
import Smallpost from "../smallpost"
function Postrender() {
  const [biggest, setbiggest] = useState(false)
  return (
    <div>
      <StaticQuery
        query={homearticle}
        render={data => {
          return (
            <div className="article-home-posts">
              <Row className="justify-content-md-center">
                <Col md={8}>
                  <div className="three-big">

                    <Row>
                      {data.allMarkdownRemark.edges
                        .slice(0,2)
                        .map(({ node }) => (
                          <Col xs={12} sm={6} className="two-smaller-posts">
                            <Post
                              key={node.id}
                              title={node.frontmatter.title}
                              date={node.frontmatter.date}
                              slug={node.fields.slug}
                              body={node.excerpt}
                              fluid={
                                node.frontmatter.image.childImageSharp.fluid
                              }
                            />
                          </Col>
                        ))}
                    </Row>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="other-scroll">
                    {data.allMarkdownRemark.edges
                      .slice(2, 5)
                      .map(({ node }) => (
                        <div>
                          <Smallpost
                            key={node.id}
                            title={node.frontmatter.title}
                            date={node.frontmatter.date}
                            slug={node.fields.slug}
                            body={node.excerpt}
                            fluid={node.frontmatter.image.childImageSharp.fluid}
                          />
                          <br />
                        </div>
                      ))}
                      <Link to="./articlepage">
                        <span className="badge">
                        more
                      </span>
                      </Link>
                      
                  </div>
                </Col>
              </Row>
            </div>
          )
        }}
      />
    </div>
  )
}

const Articlehome = () => {
  return (
    <div className="home-article-blog">
      <div className="all-posts">{Postrender()}</div>
    </div>
  )
}
const homearticle = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { cat: { eq: "article" } } }) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            image {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            cat
          }
          excerpt(truncate: true)
          fields {
            slug
          }
        }
      }
    }
  }
`

export default Articlehome

//   filter: { frontmatter: { cat: { eq: "news" } } }
